import type { OpenLoginRegisterPopupOptions } from "./LoginRegisterPopup.types";

export const LOGIN_REGISTER_POPUP_EVENT = "show-login-register-popup";
export const CLOSE_LOGIN_REGISTER_POPUP_EVENT = "close-login-register-popup";

// CustomEvent 是 fire-and-forget：若 LoginRegisterPopup 的监听器尚未挂载
// （如首页自动触发早于 App 弹窗区域 commit），事件会丢失且不再重试。
// 这里在监听器就绪前缓存最后一次 open 请求，挂载时由
// consumePendingLoginRegisterPopup 消费，保证自动弹窗不被时序竞态吞掉。
let listenerReady = false;
let pendingOptions: OpenLoginRegisterPopupOptions | null = null;

export const openLoginRegisterPopup = (
  options?: OpenLoginRegisterPopupOptions
) => {
  if (!listenerReady) {
    pendingOptions = options || {};
    return;
  }
  window.dispatchEvent(
    new CustomEvent(LOGIN_REGISTER_POPUP_EVENT, {
      detail: options || {},
    })
  );
};

export const closeLoginRegisterPopup = () => {
  pendingOptions = null;
  window.dispatchEvent(new CustomEvent(CLOSE_LOGIN_REGISTER_POPUP_EVENT));
};

/** 监听器挂载完成时调用：标记就绪并取走挂载前缓存的 open 请求（若有） */
export const consumePendingLoginRegisterPopup =
  (): OpenLoginRegisterPopupOptions | null => {
    listenerReady = true;
    const pending = pendingOptions;
    pendingOptions = null;
    return pending;
  };

/** 监听器卸载时调用：后续 open 请求重新进入缓存 */
export const releaseLoginRegisterPopupListener = () => {
  listenerReady = false;
};
